import { useIntl } from 'react-intl';
import Dialog from '@alltrails/denali/components/Dialog';

type HidePOIConfirmationProps = {
  onHide: (e?: React.MouseEvent<HTMLElement>) => void;
  setShowHideConfirmation: (show: boolean) => void;
  isHiding: boolean;
  popupCardType: 'poi' | 'photospot';
};

const HidePOIConfirmation = ({ onHide, setShowHideConfirmation, isHiding, popupCardType }: HidePOIConfirmationProps) => {
  const intl = useIntl();
  const type = popupCardType === 'poi' ? 'POI' : 'photospot';
  return (
    <Dialog
      title={intl.formatMessage({ defaultMessage: 'Hide {type}?' }, { type })}
      body={intl.formatMessage({ defaultMessage: 'Are you sure you want to hide this {type}?' }, { type })}
      buttons={{
        primary: {
          onClick: e => onHide(e),
          text: intl.formatMessage({ defaultMessage: 'Hide' }),
          loading: isHiding
        },
        flat: {
          onClick: () => setShowHideConfirmation(false),
          text: intl.formatMessage({ defaultMessage: 'Cancel' })
        }
      }}
      onRequestClose={() => setShowHideConfirmation(false)}
      size="sm"
    />
  );
};

export default HidePOIConfirmation;
